/**
 * PokeLegends MX — Additive JS layer for Dawn
 * - Testimonials carousel controls
 * - Product image zoom modal (in addition to Dawn's built-in zoom)
 * - Keyboard shortcut "/" to focus header search
 * Does NOT replace Dawn's product-info.js or product-media-gallery.
 */

(function () {
  // --- Testimonials carousel controls ---
  document.querySelectorAll('[data-pl-testimonials]').forEach((root) => {
    const track = root.querySelector('[data-pl-testimonials-track]');
    const prev = root.querySelector('[data-pl-testimonials-prev]');
    const next = root.querySelector('[data-pl-testimonials-next]');
    if (!track) return;

    const step = () => Math.min(track.clientWidth * 0.9, 420);
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  // --- Keyboard shortcut "/" to focus search input ---
  document.addEventListener('keydown', (event) => {
    if (event.key !== '/' || event.target.matches('input, textarea, [contenteditable]')) return;
    const input = document.querySelector('input[type="search"], .search__input');
    if (!input) return;
    event.preventDefault();
    input.focus();
  });

  // --- Extra zoom modal for product images (works alongside Dawn's modal) ---
  document.querySelectorAll('[data-pl-zoom-trigger]').forEach((el) => {
    el.addEventListener('click', () => {
      const src = el.dataset.plZoomSrc || el.getAttribute('data-pl-zoom-src');
      if (!src) return;
      openZoom(src);
    });
  });

  function openZoom(src) {
    const overlay = document.createElement('div');
    overlay.className = 'pl-zoom-overlay';
    overlay.style.cssText = [
      'position:fixed',
      'inset:0',
      'background:rgba(0,0,0,.88)',
      'display:grid',
      'place-items:center',
      'padding:1rem',
      'z-index:9999',
      'cursor:zoom-out'
    ].join(';');

    const img = document.createElement('img');
    img.src = src;
    img.alt = 'Imagen ampliada';
    img.style.cssText = 'max-width:96%;max-height:92vh;object-fit:contain;border-radius:18px;box-shadow:0 24px 60px rgba(0,0,0,.6);';

    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = '✕';
    close.setAttribute('aria-label', 'Cerrar');
    close.style.cssText = [
      'position:absolute',
      'top:1rem',
      'right:1rem',
      'width:44px',
      'height:44px',
      'border-radius:50%',
      'border:1px solid #272730',
      'background:#10111a',
      'color:#ededee',
      'cursor:pointer'
    ].join(';');

    overlay.appendChild(img);
    overlay.appendChild(close);
    document.body.appendChild(overlay);
    document.body.classList.add('pl-modal-open');

    const dispose = () => {
      overlay.remove();
      document.body.classList.remove('pl-modal-open');
      document.removeEventListener('keydown', escHandler);
    };
    const escHandler = (e) => { if (e.key === 'Escape') dispose(); };
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay || event.target === close) dispose();
    });
    document.addEventListener('keydown', escHandler);
  }
})();
